import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
/** Returns a dispatched action that will focus on the comment box with the given ids */
export default function useFocusOnCommentBox(commentableTypeId, commentableItemId, position, scrollIntoView, extraHeaderHeight) {
    if (scrollIntoView === void 0) { scrollIntoView = true; }
    if (extraHeaderHeight === void 0) { extraHeaderHeight = 0; }
    var dispatch = useDispatch();
    var commentBoxId = getCommentBoxId(commentableTypeId, commentableItemId, position);
    var isMobile = useContext(MobileContext);
    return useCallback(function () {
        dispatch(focusEditor(commentBoxId));
        if (scrollIntoView && typeof document !== 'undefined') {
            var boxElement = document.getElementById(commentBoxId);
            boxElement &&
                scrollIntoViewWithHeader(boxElement, isMobile, extraHeaderHeight, undefined, true, true);
        }
    }, [dispatch, commentBoxId, scrollIntoView, isMobile, extraHeaderHeight]);
}
//# sourceMappingURL=useFocusOnCommentBox.js.map